<svg class="chart-donut-svg">
    <g class="chart-donut-labels"></g>
    <g class="chart-donut-arcs"></g>
</svg>
